export default "__VITE_ASSET__DJByVdCR__"